import React, { useState , useEffect } from 'react';
import { Link } from 'react-router-dom';
import swal from 'sweetalert';

const Contact = (props)=>  {


    useEffect(() => {
        window.scrollTo(0, 0)

    }, []);




        return (
            <div>
                <div className="bg-light py-3">
                    <div className="container">
                        <div className="row">
                            <div className="col-md-12 mb-0"><Link to="/">Home</Link> <span className="mx-2 mb-0">/</span> <strong className="text-black">Return/Exchange Policy</strong></div>
                        </div>
                    </div>
                </div>
                <div className="container" style={{width : "99% " ,padding : "30px 30px"}}>
                        <div className="row">
                            <div className="col-xl-12 col-lg-12 col-md-12">
                                <div style={{fontWeight :"bold"}}>
                                {/* <h2>This Privacy Policy</h2> */}
                                <h1>Return/Exchange Policy</h1>
    <p>
        Items purchased from our online store can be sent back for exchange via courier. The customer can contact our customer services via WhatsApp or email before sending the items through courier.
    </p>

    <h2>Exchange Conditions</h2>
    <p>
        MALOOK allows its customers to exchange the purchased items subject to the following conditions:
    </p>
    <ul>
        <li>The customer has submitted a request for exchange (via WhatsApp or email) within 7 working days of receipt of the purchased item.</li>
        <li>The customer has stated the reason(s) for the exchange in their request.</li>
        <li>The item is in its original packing and the original tags are intact.</li>
        <li>The original invoice of the item being exchanged is sent along with the item.</li>
        <li>The item to be exchanged has no emits, odours, perfume scents, stains, or anything suggesting the item was used.</li>
        <li>The item is not customized for size or made to order for the customer.</li>
    </ul>
    <p>
        Items bought on sale cannot be exchanged. If an item bought at regular price goes on sale, it will be exchanged at the sale price. MALOOK has the right, at its sole discretion, to accept or deny the request for exchange.
    </p>
    <p>
        Upon acceptance of the request for exchange, the customer will be notified by our customer service.
    </p>
    <p>
        This exchange policy only applies to orders shipped within Pakistan. For international orders, the above policy applies if the customer deposits shipping charges for the second dispatch in advance.
    </p>
    <p>
        MALOOK strictly follows a ‘NO refund’ policy. The option of cashback is not available.
    </p>
    <p>
        Please note that items purchased from our Studio cannot be sent to us for exchange through courier. These items can be exchanged at our Studio only. Exchange cannot be made when a product has been made to order or personalized or made according to the customer measurements.
    </p>

    <h2>Damage & Claims</h2>
    <p>
        The exchange of damaged item(s) will be allowed if the item(s) received has any kind of manufacturing defect, shipment of wrong size, or wrong item. The complaint in such cases must be raised within 2 working days (via WhatsApp or email) after receiving the parcel.
    </p>
    <p>
        All formals or bridals due to non-payment are not eligible for a refund. The customer is provided a 7-day notice to pay. No refund of the advance payment.
    </p>

    <div class="note">
        <strong>Note:</strong> Please ensure to follow the above conditions to facilitate a smooth exchange process.
    </div>
                                </div>
                            </div>
                        </div>
                </div>
            </div>
        )
    
}


export default Contact;